import { render, staticRenderFns } from "./Goalspage.vue?vue&type=template&id=66a6be1e&"
import script from "./Goalspage.vue?vue&type=script&lang=js&"
export * from "./Goalspage.vue?vue&type=script&lang=js&"
import style0 from "./Goalspage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports